import React from "react";

// Components
import {Icon, symbolUrl} from '../../common';

export default function SearchResults({
    searchResults,
    vehicleResults,
    vehicleLimit,
    pageLimit,
    loading
}) {
    const pages = searchResults.default;
    const loadingArticleElements = [1, 2, 3];

    return (
        <div className="row gutters-6 gutters-lg-16">
            <div className="col-12 col-lg-8">
                <h5 className="mb-2 mb-lg-4">Pagina&apos;s</h5>
                {loading &&
                    loadingArticleElements.map((element, elementIndex) => (
                        <div key={elementIndex} className="loading--paragraph">
                            <span className="loading__title" />
                        </div>
                    ))} 
                {Object.entries(searchResults).length !== 0 && pages.items.length > 0 && (
                    <ul className="list list--links">
                        {pages.items.map((result, resultIndex) => {
                            if (resultIndex < pageLimit) {
                                return (
                                    <li key={resultIndex} className="list__item">
                                        <a href={result.url} className="list__link">
                                            <span className="list__text text-truncate">{result.name}</span>
                                            <Icon url={symbolUrl('chevron-right')} size="16" classes="mx-2" />
                                        </a>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                )}
                {!loading &&
                    Object.entries(searchResults).length !== 0 &&
                    pages.items.length == 0 &&<p>Geen resultaten gevonden, probeer een andere zoekterm.</p>}
            </div>
            <div className="col-12 col-lg-8">
                {vehicleResults.length > 0 && (
                    <h5 className="mb-2 mb-lg-4">Voertuigen</h5>
                )}
                {!loading && vehicleResults.length == 0 && (
                    <>
                        <h5 className="mb-2 mb-lg-4">Voertuigen</h5>
                        <p>Geen voertuigen gevonden, probeer een andere zoekterm.</p>
                    </>
                )}
                {loading &&
                    loadingArticleElements.map((element, elementIndex) => (
                        <div key={elementIndex} className="loading--paragraph">
                            <span className="loading__title" />
                        </div>
                    ))}
                <ul className="list list--links">
                    {vehicleResults.length > 0 &&
                        vehicleResults.map((vehicle, vehicleIndex) => {
                            if (vehicleIndex < vehicleLimit) {
                                return (
                                    <li key={vehicleIndex} className="list__item">
                                        <a href={vehicle.url} className="list__link" title="">
                                            <span className="list__text text-truncate">{vehicle.brand} {vehicle.model}</span>
                                            <Icon url={symbolUrl('chevron-right')} size="16" classes="mx-2" />
                                        </a>
                                    </li>
                                );
                            }
                        })}
                </ul>
            </div>
        </div>
    );
}
